import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Breakpoints } from '../../../utils';
import { assetsNoResults } from '../../../images';
import { SearchResultsPlaceholder } from '../..';
import Desktop from './Desktop';
import Mobile from './Mobile';
import { useMediaQuery } from 'react-responsive';

const assets = {
  priceList: 'price list'
};

const AssetPlaceholder = ({ assetType }) => (
  <Fragment>
    <p>
      <FormattedMessage
        id="description.price_list_empty"
        values={{ assetType }}
      />
      <ol>
        <li>
          <FormattedMessage id="description.price_list_reason1" />
        </li>
        <li>
          <FormattedMessage id="description.price_list_reason2" />
        </li>
      </ol>
    </p>
    <p>
      <FormattedMessage
        id="description.price_list_empty_cta"
        values={{
          email: (
            <a href="mailto:agidealersupport@aggrowth.com">
              agidealersupport@aggrowth.com
            </a>
          )
        }}
      />
    </p>
  </Fragment>
);

const Placeholder = ({ assetType }) => {
  const asset = assets[assetType] ? assets[assetType] : assetType;
  return (
    <SearchResultsPlaceholder
      images={[assetsNoResults]}
      header={
        <FormattedMessage
          id="subtitle.no_results"
          defaultMessage="No Results"
        />
      }
    >
      <AssetPlaceholder assetType={asset} />
    </SearchResultsPlaceholder>
  );
};

const Body = ({ assetType, ...rest }) => {
  const props = {
    ...rest,
    placeholder: <Placeholder assetType={assetType} />
  };

  const isMobile = useMediaQuery({
    maxWidth: Breakpoints.computerBreakpoint - 1
  });
  const isDesktop = useMediaQuery({ minWidth: Breakpoints.computerBreakpoint });

  return (
    <Fragment>
      {isMobile && <Mobile {...props} />}
      {isDesktop && <Desktop {...props} />}
    </Fragment>
  );
};

export default Body;
